var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
var getGridRow = function (row, span) {
    return span ? parseInt(row) + 1 + " / span " + span : parseInt(row) + 1;
};
var getGridColumn = function (column, span) {
    return span ? parseInt(column) + 1 + " / span " + span : parseInt(column) + 1;
};
var StyledGridLayoutItem = styled.div.attrs(function (props) { return ({
    className: 'gridLayoutItem',
}); })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: ", ";\n  display: ", ";\n  flex-direction: ", ";\n  grid-row: ", ";\n  grid-column: ", ";\n  background: ", ";\n  margin-top: ", ";\n  margin-right: ", ";\n  margin-bottom: ", ";\n  margin-left: ", ";\n  min-height: ", ";\n  overflow: ", ";\n  * {\n    box-sizing: ", ";\n  }\n  > * {\n    flex: ", ";\n  }\n  input:not([type='checkbox']):not([type='radio']),\n  select {\n    padding: 0;\n    width: 100%;\n    /* height: 100%; */\n  }\n"], ["\n  position: ", ";\n  display: ", ";\n  flex-direction: ",
    ";\n  grid-row: ", ";\n  grid-column: ", ";\n  background: ", ";\n  margin-top: ", ";\n  margin-right: ", ";\n  margin-bottom: ",
    ";\n  margin-left: ", ";\n  min-height: ", ";\n  overflow: ", ";\n  * {\n    box-sizing: ", ";\n  }\n  > * {\n    flex: ", ";\n  }\n  input:not([type='checkbox']):not([type='radio']),\n  select {\n    padding: 0;\n    width: 100%;\n    /* height: 100%; */\n  }\n"])), function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.gridLayout.item.position;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.gridLayout.item.display;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.gridLayout.item.flexDirection;
}, function (_a) {
    var row = _a.row, rowspan = _a.rowspan;
    return getGridRow(row, rowspan);
}, function (_a) {
    var column = _a.column, colspan = _a.colspan;
    return getGridColumn(column, colspan);
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.gridLayout.item.background;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.gridLayout.item.marginTop;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.gridLayout.item.marginRight;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.gridLayout.item.marginBottom;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.gridLayout.item.marginLeft;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.gridLayout.item.minHeight;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.gridLayout.item.overflow;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.gridLayout.item.boxSizing;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.gridLayout.item.content.flex;
});
var GridLayoutItem = function (props) {
    var attributes = props.attributes, children = props.children, restProps = __rest(props, ["attributes", "children"]), text = attributes.text;
    return (React.createElement(StyledGridLayoutItem, __assign({}, restProps),
        text,
        children));
};
export default GridLayoutItem;
var templateObject_1;
//# sourceMappingURL=gridLayoutItem.js.map